import React from "react";
import { COLORS } from "../constants";
import { pill, fontSerif } from "./styles";

function ModeButton({ active, onClick, children, testId, id, compact }) {
  return (
    <button
      data-testid={testId}
      id={id}
      onClick={onClick}
      style={{
        padding: compact ? "6px 12px" : "8px 18px",
        borderRadius: 999,
        border: "none",
        cursor: "pointer",
        backgroundColor: active ? COLORS.gold : "transparent",
        color: active ? COLORS.navyDeep : COLORS.ivory,
        fontFamily: fontSerif,
        fontSize: compact ? 11 : 13,
        letterSpacing: 1,
        textTransform: "uppercase",
        fontWeight: 600,
        transition: "background-color .2s, color .2s",
      }}
    >
      {children}
    </button>
  );
}

export default function ModeControls({ mode, enterOrbit, enterWalk, inline = false, compact = false }) {
  const wrapperStyle = inline
    ? {
        pointerEvents: "auto",
        display: "flex",
        gap: compact ? 4 : 8,
        padding: compact ? 3 : 4,
        ...pill,
      }
    : {
        position: "absolute",
        top: 20,
        right: 24,
        pointerEvents: "auto",
        display: "flex",
        gap: 8,
        padding: 4,
        ...pill,
      };

  return (
    <div data-testid="zone-mode-controls" style={wrapperStyle}>
      <ModeButton
        active={mode === "orbit"}
        onClick={enterOrbit}
        testId="zone-mode-orbit"
        compact={compact}
      >
        Orbit
      </ModeButton>
      <ModeButton
        active={mode === "walk"}
        onClick={enterWalk}
        testId="zone-mode-walk"
        id="zone-pointer-lock-trigger"
        compact={compact}
      >
        Walk
      </ModeButton>
    </div>
  );
}
